import { Language } from "./types";
import { adminTranslations as baseAdminTranslations } from "./i18nAdmin";

export const overviewTranslations: Record<Language, Record<string, string>> = {
  en: {
    syncingIntel: "Syncing Intel Core...",
    noStreamData: "No Stream Data Available",
    scanningGrid: "Scanning Grid...",
    total: "TOTAL",
    audit: "Audit",
    terminate: "Terminate",
    lastMonthContrast: "vs last month",
    yesterdayContrast: "vs yesterday",
  },
  ko: {
    syncingIntel: "인텔 코어 동기화 중...",
    noStreamData: "스트림 데이터가 없습니다",
    scanningGrid: "그리드 스캔 중...",
    total: "합계",
    audit: "감사",
    terminate: "중단",
    lastMonthContrast: "지난달 대비",
    yesterdayContrast: "어제 대비",
  },
  ja: {
    syncingIntel: "インテルコア同期中...",
    noStreamData: "ストリームデータがありません",
    scanningGrid: "グリッドスキャン中...",
    total: "合計",
    audit: "監査",
    terminate: "中断",
    lastMonthContrast: "先月比",
    yesterdayContrast: "前日比",
  },
  es: {
    syncingIntel: "Sincronizando Núcleo Intel...",
    noStreamData: "Sin Datos de Transmisión",
    scanningGrid: "Escaneando Cuadrícula...",
    total: "TOTAL",
    audit: "Auditoría",
    terminate: "Terminar",
    lastMonthContrast: "vs mes anterior",
    yesterdayContrast: "vs ayer",
  },
  fr: {
    syncingIntel: "Sinc. du Noyau Intel...",
    noStreamData: "Aucune Donnée de Flux",
    scanningGrid: "Analyse de la Grille...",
    total: "TOTAL",
    audit: "Audit",
    terminate: "Terminer",
    lastMonthContrast: "vs mois dernier",
    yesterdayContrast: "vs hier",
  },
};

export const extendedAdminTranslations: Record<string, Record<string, string>> = {};

(Object.keys(baseAdminTranslations) as Language[]).forEach((lang) => {
  extendedAdminTranslations[lang] = {
    ...baseAdminTranslations[lang],
    ...(overviewTranslations[lang] || overviewTranslations["en"]),
  };
});

export const axt = (lang: Language, key: string): string => {
  return (extendedAdminTranslations[lang] || baseAdminTranslations[lang])?.[key] || key;
};
